<template>
  <div class="reg">
    <!-- 登录注册 -->
    <el-dialog
      title="参赛报名流程"
      custom-class="login-form"
      :visible.sync="competitionVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-container>
        <div style="margin:10px 0px 10px 30px;">
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              :icon="activity.icon"
              :type="activity.type"
              :color="activity.color"
              :size="activity.size"
              :timestamp="activity.timestamp"
            >{{activity.content}}</el-timeline-item>
          </el-timeline>
        </div>
      </el-container>
      <div>
        <el-row>
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
          >
          <div style="padding-left:10%">
            <h3>请先注册/登录网站</h3>
          </div>
          </el-col>
          <el-col
            :xs="24"
            :sm="24"
            :md="12"
            :lg="12"
            :xl="12"
          >
            <div style>
              <el-button
                type="success"
                style="background:#0c70fc;width:50%;"
                @click="login"
              >登 录</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <login></login>
    </el-dialog>
  </div>
</template>

<script>
import login from "../components/login";
export default {
  components: { login},
  data() {
    return {
      isDisabled: false,
      competitionVisible: this.$store.state.competitionVisible,
      user: this.$store.state.user,
      activities: [
        {
          content: "注册/登陆网站",
          size: "large",
          color: "#0bbd87"
        },
        {
          content: "用户报名",
          size: "large"
        },
        {
          content: "作品申报",
          size: "large"
        },
        {
          content: "专家评审",
          size: "large"
        },
        {
          content: "获奖公布",
          size: "large"
        }
      ]
    };
  },
  watch: {
    "$store.state.competitionVisible": function(newFlag, oldFlag) {
      this.competitionVisible = newFlag;
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      // this.$parent.loginVisible = false
      // this.$parent.registerFormVisible = false;
      this.$store.commit("competitionMutations", false);
    },
    login() {
      if (!this.user) {
        this.$store.commit("competitionMutations", false);
        this.loginIn(1)
      }
    },
    loginIn(index) {
      if (index == 1) {
        this.$store.commit("loginVisibleMutations", true);
      } else if (index == 2) {
        this.$store.commit("registerFormVisibleMutations", true);
      } else if (index == 3)  {
        this.$store.commit("competitionMutations", true);
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.grid-content {
  height: 60px;
}
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
}
.register {
  color: #1ab2ff;
  cursor: pointer;
}
.register:hover {
  color: #2c2fd6;
}
</style>

<style >
.reg {
  width: 100%;
}
.reg .el-tabs__nav {
  width: 100%;
  float: none;
}
.reg .el-tabs__active-bar {
  background-color: #e4e7ed;
  height: 0px;
}
.reg .el-radio-group {
  float: left;
  position: relative;
  top: 12px;
}
.reg .el-tabs__nav-wrap::after {
  background-color: white;
}
.reg .el-dialog .el-dialog__body {
  padding: 30px 60px !important;
}
/* .el-dialog__headerbtn.el-dialog__headerbtn .el-dialog__close {
  display: none;
} */
.reg .el-form-item__content .el-button--primary {
  width: 100%;
}
.reg .login-code .el-button {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding: 0;
  color: #0c70fc;
  background-color: #eeeeee;
}
/*  */
.reg .el-radio-button--small .el-radio-button__inner {
  padding: 5px 5px !important;
}
.reg .el-input__inner {
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
}
.reg a {
  text-decoration: none;
  color: #0c70fc;
}
.reg .xieyi {
  color: #fcae48;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/competition.vue